import clsx from 'clsx';

export default function Note({ children, className }: NoteProps) {

    const noteClasses = clsx('note', className);

    return <div className={noteClasses}>
        {children}
    </div>;
}
